import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject, of, map } from 'rxjs';
import { SocketService } from './socket.service';
import { ConfigService } from './config.service';
import { MessageWebFeeder } from '@model/webFeeder/message-web-feeder.model';
import { LoginDuplicatedEnum } from '@model/enum/login-duplicated.enum';

@Injectable({ providedIn: 'root' })
export class ScktLoginDuplicatedService {

  private serviceSubject = new Subject<MessageEvent>();
  messagesLoginDuplicated: Observable<any>;

  // 0 = OFF | 1 = ON Difusion | 2 = Reload Page | 3 = Logout
  _authLoginDuplicated = new BehaviorSubject<number>(LoginDuplicatedEnum.OFFLINE);
  authLoginDuplicated$ = this._authLoginDuplicated.asObservable();

  constructor(
    private _socketService: SocketService,
    private _configService: ConfigService,
  ) { }

  public createSubject() {
    const newService = { name: 'loginDuplicated', serviceSubject: this.serviceSubject };
    this._socketService.register(newService);
    this.messagesLoginDuplicated = newService.serviceSubject
      .pipe(map(data => {
        if (data.type === 'loginDuplicated') {
          return data;
        }
        return data;
      }));
  }

  subscribeLoginDuplicated(account, componentName: string) {
    if (!account) {
      return of('Conta não informada.');
    }
    this.sendMessageLoginDuplicated(account, true);
    this._configService.writeLog('SUBSCRIBE LOGIN DUPLICATED > [' + account.toString().toUpperCase() + '][' + (componentName ? componentName.toUpperCase() : null) + '] <<<<<');
    return of();
  }

  unsubscribeLoginDuplicated(account, componentName: string) {
    if (!account) {
      return of('Conta não informada.');
    }
    this.sendMessageLoginDuplicated(account, false);
    this._configService.writeLog('UNSUBSCRIBE LOGIN DUPLICATED > [' + account.toString().toUpperCase() + '][' + (componentName ? componentName.toUpperCase() : null) + '] <<<<<');
    return of();
  }

  private sendMessageLoginDuplicated(account, status: boolean) {
    const accountTemp = typeof account === 'string' ? account : account[0];
    if (accountTemp) {
      const dataMsg: MessageWebFeeder = new MessageWebFeeder();
      dataMsg.token = this._configService.getToken();
      dataMsg.module = 'negotiation';
      dataMsg.service = 'loginDuplicated';
      dataMsg.parameters = { 'username': accountTemp.toUpperCase(), 'dispatch': status };
      setTimeout(() => {
        this._socketService.signService(dataMsg);
      }, 1000);
    }
  }

}
